import React from 'react';
import { Outlet } from 'react-router-dom';
import { Footer, Navbar } from '../../pages';

const Layout = () => {
  return (
    <>
      <Navbar />
      <Outlet></Outlet>
      <Footer />
    </>
  );
};

export default Layout;
